<div class="cell auto" *ngIf="parameters">
    <kiwi-parameters-tab-content-header
        [saveDisabled]="areParametersReadonly()"
        (saved)="updateParameters()"
        [titleLabelKey]="'parameters.quality.perceived.quality.title'">
    </kiwi-parameters-tab-content-header>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <p [i18nKey]="'parameters.quality.perceived.quality.description'"></p>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <table class="_tableColor">
        <thead>
            <tr class="_titlePartTable">
                <th></th>
                <th [i18nKey]="'parameters.quality.perceived.quality.weight'"></th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td [i18nKey]="'parameters.quality.perceived.quality.advertisement'"></td>
                <td>
                    <input type="number" [(ngModel)]="parameters.advertisementQualityWeight" [disabled]="areParametersReadonly()" />
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'parameters.quality.perceived.quality.cooking'"></td>
                <td>
                    <input type="number" [(ngModel)]="parameters.cookingQualityWeight" [disabled]="areParametersReadonly()" />
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'parameters.quality.perceived.quality.customer.care'"></td>
                <td>
                    <input type="number" [(ngModel)]="parameters.customerCareQualityWeight" [disabled]="areParametersReadonly()" />
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'parameters.quality.perceived.quality.layout'"></td>
                <td>
                    <input type="number" [(ngModel)]="parameters.layoutQualityWeight" [disabled]="areParametersReadonly()" />
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'parameters.quality.perceived.quality.maintenance'"></td>
                <td>
                    <input type="number" [(ngModel)]="parameters.maintenanceQualityWeight" [disabled]="areParametersReadonly()" />
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'parameters.quality.perceived.quality.menu'"></td>
                <td>
                    <input type="number" [(ngModel)]="parameters.menuQualityWeight" [disabled]="areParametersReadonly()" />
                </td>
            </tr>
        </tbody>
    </table>
</div>
